import { render, staticRenderFns } from "./DataAnalisysPivotViewComponent.vue?vue&type=template&id=10b0b053&scoped=true"
import script from "./DataAnalisysPivotViewComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalisysPivotViewComponent.vue?vue&type=script&lang=js"
import style0 from "./DataAnalisysPivotViewComponent.vue?vue&type=style&index=0&id=10b0b053&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0b053",
  null
  
)

export default component.exports